import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  templateUrl: './checklist.component.html',
})
export class ChecklistComponent implements OnInit {

  GetfilteredData: any[] = [];
  filteredData: any;
  Empdatas: any[] = [];
  BalanceSheetdata: any[] = [];
  Borrowerdatas: any[] = [];
  datas: any = {}; // Change from any[] to any

  AuditStatus: any[] = [];
  iSocietyDetailsId: any;
  iAllotAuditorID:any;
  iSocietyDetailTranID:any;
  page = new Page();
  name: string = '';
  names: string = '';
  rowsData: any[] = [];
  rows: any[] = [];
  FatchedData: any[] = [];
  filteredRows: any[] = [];
  loading = false;
  columns: any[] = [];
  column: any[] = [];
  col: any[] = [];
  cols: any[] = [];
  row: any[] = [];
  selected: any[] = [];
  rowses: any[] = [];
  borower: any[] = [];
  iTSocietyEmpID: number | 0 = 0;
  iSocietyBorrowerDetails: number | 0 = 0;
  iBalanceSheetID: number | 0 = 0;
  modalId: string = '';
  rowsesLiabilities: any;
  rowsAssets: any;
  rowsesAssets: any;
  isUpdateVisible: boolean = false;
  isFormSubmitted: boolean = false;
  isReadOnly: boolean = false;
  status: any;
  gender: any[] = [];
  category: any[] = [];
  balanceSheet: any[] = [];
  bsParameter: any[] = [];
  checklistData: any = {};

  currentToggleId1: string = 'collapseOne';
  currentToggleId2: string = 'collapseTwo';
  currentToggleId3: string = 'collapseThree';
  currentToggleId4: string = 'collapseFour';
  currentToggleId5: string = 'collapseFive';
  currentToggleId6: string = 'collapseSix';
  currentToggleId7: string = 'collapseSeven';
  transId: number | 0 = 0;
  selectedServices: any[] = [];
  completed = false;
  hasSubmittedRemark = false;
  moveforward = false;
  isDeleteDisabled = false;
  isNonCreditSociety: any;
  lstAuditProcess: any;
  SocietyBussinessFields: any;
  dataAuditParameter: any;
  allDataLoaded = false;
  isAnyCheckboxChecked: boolean = false;
  currentYear: number = new Date().getFullYear();
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  base64String2: string = '';
  base64String: string = '';

  newEMP = {
    sSocietyEmpTypes: '',
    noOfEmployee: 0,
    transId: 0
  };
  newUpload = {
    documentPath: '',
    status: '',
    isChecked: false,
    transId: 0,
    documentFileName: '',
    documentExtension: ''

  };
  borrowers: any[] = [];
  showDownload: boolean = false;
  uploadedFilePath: string = '';

  newBalance = {
    iSocietyCommonParameterID: 0,
    type: '',
    sAmount: '',
    sParameterType: '',
    OtherParameter: '',
    transId: 0
  };

  newSociety = {
    statusSocieties: '',
    noOfMember: 0,
    apexInstituteSociety: 0,
    gender: '',
    membercount: 0,
    isCorporativeBank: false,
    memberCommitee: 0,
    electedMember: 0,
    vacantMember: 0,
    trainedEmp: 0,
    unTrainedEmp: 0,
    partTimeSC: 0,
    fullTimeSC: 0,
    transId: 0,
    cooperativeBankBranches: 0

  };
  building = {
    iSocietyTransID: 0,
    societyBuilding: false,
    buildingType: '',
    sRemarks: '',
    landDetails: false,
    possessionType: '',
    sArea: 0

  }
  confirmationMessage: string = '';
  deleteBalance: string = '';
  deleteservice: string = '';
  dataBussinessTurnOver: any;
  dataCooperative: any = {};

  lstBorrowerDetails: any;
  lstEmpDetails: any;
  empList: any;
  dataNonCredit: any;
  lstBalanceSheet: any;
  dataCommonAuditParameters: any;
  lstBussinessServices: any;
  lstBussinessUpgrades: any;
  dataBasicCommonParameter: any;
  completeStatus: any
  lstCheckListBussiness: any;
  lstPropertyData: any;
  lstEmployees: any;
  isEditing: boolean = true;
  newnonCredit = {
    sTrainingNo: '',
    sSpecificAuditYearArea: '',
    sNoTrainedConducted: '',
    sNoTeachingWorkers: '',
    sNoOtherStaff: '',
    transId: 0
  };
  newAuditPera = {
    transid: 0,
    sTotalOutStanding: 0,
    sSpecificTrainingArea: 0
  }
  newchecked =
    {

      iBussinessSerID: 0,
      transId: this.transId,
      iTBussinessFieldID: 0,
      value: ""
    };


  newcoprateSocity = {
    sLoanAgriculture: '',
    sLoanNonAgriculture: '',
    sLoanDistributionShort: '',
    sLoanDistributionMedium: '',
    sLoanDistributionLong: '',
    sLoanRecoveryShort: '',
    sLoanRecoveryMedium: '',
    sLoanRecoveryLong: '',
    sLoanOutstandingShort: '',
    sLoanOutstandingMedium: '',
    sLoanOutstandingLong: '',
    sLoanOverdueShort: '',
    sLoanOverdueMedium: '',
    sLoanOverdueLong: '',
    transId: 0
  };



  remark = {
    remarks: '',
    transId: 0
  };
  borrower = {
    iSocietyCreditCoOperativeID: 0,
    sCasteCategory: '',
    sDefaulterName: '',
    sAmount: '',
    transId: 0

  };



  commanPerameter = {
    sIncome: 0,
    sExpenditure: '',
    sProfit: 0,
    sLoss: 0,
    sGSTNO: '',
    sPANNo: '',
    sTanNo: '',
    sEPFNo: '',
    isSpecialReport: true,
    sWorkingCapital: 0,
    sAuditFee: 0,
    sAmountInvolved: 0,
    sDateOfDetection: '',
    transId: 0,
    sAuditYear: 0,
    sAuditClassification: '',
    sAuditorName: '',
    dAuditAllotmentDate: '',
    dAuditStartDate: '',
    dSubmitDate: '',
    dDateOfElection: '',
    dGeneralHouseMeeting: '',
    member: 0,
    totalshare: 0,
    govtshares: false,
    govtShare: 0,
    redemptionGovtShare: 0,
    govtDividentPayable: 0,
    govtDividentPaid: 0,
    govtLoan: 0,
    recoveryOfPrincipalInt: 0,
    specifyFacilitiesService: ''
  };
  yearOptions: number[] = [];

  isCreditSociety: boolean = false;
  apexSociety: boolean = false;
  primarySociety: boolean = false;
  cd: any;
  configService: any;


  constructor(
    private auditService: AuditService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
      this.page.totalRecords = 0;
    }

    this.isCreditSociety = this.filteredData?.[0]?.society === 'Credit';
    this.primarySociety = this.filteredData?.[0]?.level === 'Primary';
    this.apexSociety = this.filteredData?.[0]?.level === 'Apex' || this.filteredData?.[0]?.level === 'Secondary';

    this.route.params.subscribe((params) => {
      if (params['iSocietyDetailsId']) {
        this.iSocietyDetailsId = parseInt(params['iSocietyDetailsId']);
        this.loadAuditors(this.iSocietyDetailsId);
      }
    });
  }
  ngOnInit(): void {
    this.loadAuditors(this.iSocietyDetailsId);
    this.fetchUpdatedData();
    this.GetCommanData();
    this.getBorrowerList();
    this.setPage(this.iSocietyDetailsId);
    this.EmpData();
    this.getBalanceList();
    const currentYear = new Date().getFullYear();
    for (let year = 2010; year <= currentYear + 5; year++) {
      this.yearOptions.push(year);
    }

  }

  fetchUpdatedData() {
    const id = this.iSocietyDetailsId;
    const actionName = "InProcess";
    const auditorId = this.iAllotAuditorID;
    const iSocietyDetailTranID =this.iSocietyDetailTranID;

    this.auditService.GetTransId(id, actionName,auditorId,iSocietyDetailTranID).subscribe(
      (response: any) => {
        if (response?.data) {
          this.datas = response.data;
          if (this.datas.dataCommonAuditParameters) {
            this.isEditing = !(
              this.datas.dataCommonAuditParameters?.sDateOfDetection ||
              this.datas.dataCommonAuditParameters?.dAuditAllotmentDate ||
              this.datas.dataCommonAuditParameters?.dAuditStartDate ||
              this.datas.dataCommonAuditParameters?.dSubmitDate ||
              this.datas.dataCommonAuditParameters?.dDateOfElection ||
              this.datas.dataCommonAuditParameters?.dGeneralHouseMeeting
            );
          } else {
            this.isEditing = true; // Default to true if commanPerameter is undefined or null
          }

          if (this.datas?.auditStatus?.isCheckListCompleted ==false && this.datas?.auditStatus?.moveForwaredByAuditor == false) {
            
            this.isReadOnly = false;
            this.isEditing = true;
            this.hasSubmittedRemark = false;
            this.isDeleteDisabled = false;
            this.moveforward = true;
            this.isUpdateVisible = false;
            this.isFormSubmitted = false;



          } else if (this.datas?.auditStatus?.isCheckListCompleted == true && this.datas?.auditStatus?.moveForwaredByAuditor == true) {

            this.isUpdateVisible = false;
            this.isFormSubmitted = false;
            this.hasSubmittedRemark = true;
            this.isDeleteDisabled = true;
            this.isReadOnly = true;
            this.moveforward = false;

            this.isEditing = false;
            if (this.datas?.auditStatus?.documentPath) {
              this.showDownload = !!this.datas.auditStatus.documentPath.trim();
              this.uploadedFilePath = this.datas.auditStatus.documentPath;
            } else {
              this.showDownload = false;
            }
          }
          else if (this.datas?.auditStatus?.isCheckListCompleted == true && this.datas?.auditStatus?.moveForwaredByAuditor == false) {

            this.isUpdateVisible = true;
            this.isFormSubmitted = true;
            this.hasSubmittedRemark = true;
            this.isDeleteDisabled = true;
            this.isReadOnly = true;
            this.moveforward = true;

            this.isEditing = false;
            if (this.datas?.auditStatus?.documentPath) {
              this.showDownload = !!this.datas.auditStatus.documentPath.trim();
              this.uploadedFilePath = this.datas.auditStatus.documentPath;
            } else {
              this.showDownload = false;
            }
          }
          else {
            this.isUpdateVisible = false;
            this.isFormSubmitted = false;
            this.showDownload = true;
            this.moveforward = true;

          }
          this.initializeData();
        } else {
          console.warn('No data received.');
        }
      },
      (error) => {
        console.error('Error fetching updated data:', error);
      }
    );
  }
  
  initializeData() {
    this.checklistData = this.datas ?? {};

    this.dataCooperative = this.checklistData?.dataCooperative ?? null;
    this.lstBorrowerDetails = this.checklistData.lstBorrowerDetails ?? [];
    this.dataNonCredit = this.checklistData.dataNonCredit ?? null;
    this.lstBalanceSheet = this.checklistData.lstBalanceSheet ?? [];
    this.dataCommonAuditParameters = this.checklistData.dataCommonAuditParameters ?? null;
    this.lstBussinessServices = this.checklistData.lstBussinessServices ?? null;
    this.lstBussinessUpgrades = this.checklistData.lstBussinessUpgrade ?? [];
    this.lstEmployees = this.checklistData.lstEmployees ?? [];
    this.dataBasicCommonParameter = this.checklistData.dataBasicCommonParameter ?? {};
    this.completed = this.checklistData.auditStatus ?? {};
    this.completeStatus = this.checklistData.auditStatus ?? [];

    this.lstAuditProcess = this.checklistData.lstAuditProcess ?? [];
    this.SocietyBussinessFields = this.checklistData.societyBussinessFields ?? [];
    this.dataAuditParameter = this.checklistData.dataAuditParameter ?? {};
    this.newAuditPera = {
      transid: this.dataAuditParameter?.transid || 0,
      sSpecificTrainingArea: this.dataAuditParameter?.sSpecificTrainingArea || 0,
      sTotalOutStanding: this.dataAuditParameter?.sTotalOutStanding || 0
    };

    this.newEMP = {
      sSocietyEmpTypes: this.lstEmployees?.sSocietyEmpTypes || '',
      noOfEmployee: this.lstEmployees?.noOfEmployee || 0,
      transId: this.lstEmployees?.transId || 0
    };

    this.borrower = {
      iSocietyCreditCoOperativeID: this.dataCooperative?.iSocietyCreditCoOperativeID || 0,
      sCasteCategory: this.lstBorrowerDetails?.sCasteCategory || '',
      sDefaulterName: this.lstBorrowerDetails?.sDefaulterName || 0,
      sAmount: this.lstBorrowerDetails?.sAmount || 0,
      transId: this.lstBorrowerDetails?.transId || 0
    };

    // Assign values safely
    this.remark = {
      remarks: this.completeStatus?.sRemark || '',
      transId: this.completeStatus?.transId || 0,
    };


    this.newnonCredit = {
      sTrainingNo: this.dataNonCredit?.sTrainingNo || '',
      sSpecificAuditYearArea: this.dataNonCredit?.sSpecificAuditYearArea || '',
      sNoTrainedConducted: this.dataNonCredit?.sNoTrainedConducted || '',
      sNoTeachingWorkers: this.dataNonCredit?.sNoTeachingWorkers || '',
      sNoOtherStaff: this.dataNonCredit?.sNoOtherStaff || null,
      transId: this.dataNonCredit?.transId || 0,
    };

    this.newcoprateSocity = {
      sLoanAgriculture: this.dataCooperative?.sLoanAgriculture || '',
      sLoanNonAgriculture: this.dataCooperative?.sLoanNonAgriculture || '',
      sLoanDistributionShort: this.dataCooperative?.sLoanDistributionShort || '',
      sLoanDistributionMedium: this.dataCooperative?.sLoanDistributionMedium || '',
      sLoanDistributionLong: this.dataCooperative?.sLoanDistributionLong || '',
      sLoanRecoveryShort: this.dataCooperative?.sLoanRecoveryShort || '',
      sLoanRecoveryMedium: this.dataCooperative?.sLoanRecoveryMedium || '',
      sLoanRecoveryLong: this.dataCooperative?.sLoanRecoveryLong || '',
      sLoanOutstandingShort: this.dataCooperative?.sLoanOutstandingShort || '',
      sLoanOutstandingMedium: this.dataCooperative?.sLoanOutstandingMedium || '',
      sLoanOutstandingLong: this.dataCooperative?.sLoanOutstandingLong || '',
      sLoanOverdueShort: this.dataCooperative?.sLoanOverdueShort || '',
      sLoanOverdueMedium: this.dataCooperative?.sLoanOverdueMedium || '',
      sLoanOverdueLong: this.dataCooperative?.sLoanOverdueLong || '',
      transId: this.dataCooperative?.transId || 0,
    };

    this.newSociety = {
      statusSocieties: this.dataBasicCommonParameter?.statusSocieties || '',
      noOfMember: this.dataBasicCommonParameter?.noOfMember || 0,
      apexInstituteSociety: this.dataBasicCommonParameter?.apexInstituteSociety || 0,
      gender: this.dataBasicCommonParameter?.gender || '',
      membercount: this.dataBasicCommonParameter?.membercount || 0,
      isCorporativeBank: this.dataBasicCommonParameter?.isCorporativeBank || 0,
      cooperativeBankBranches: this.dataBasicCommonParameter?.cooperativeBankBranches || 0,
      memberCommitee: this.dataBasicCommonParameter?.memberCommitee || 0,
      electedMember: this.dataBasicCommonParameter?.electedMember || 0,
      vacantMember: this.dataBasicCommonParameter?.vacantMember || 0,
      trainedEmp: this.dataBasicCommonParameter?.trainedEmp || 0,
      unTrainedEmp: this.dataBasicCommonParameter?.unTrainedEmp || 0,
      partTimeSC: this.dataBasicCommonParameter?.partTimeSC || 0,
      fullTimeSC: this.dataBasicCommonParameter?.fullTimeSC || 0,
      transId: this.dataBasicCommonParameter?.transId || 0,

    };

    this.commanPerameter = {
      sIncome: this.dataCommonAuditParameters?.sIncome || 0,
      sExpenditure: this.dataCommonAuditParameters?.sExpenditure || '',
      sProfit: this.dataCommonAuditParameters?.sProfit || 0,
      sLoss: this.dataCommonAuditParameters?.sLoss || 0,
      sGSTNO: this.dataCommonAuditParameters?.sGSTNO || '',
      sPANNo: this.dataCommonAuditParameters?.sPANNo || '',
      sTanNo: this.dataCommonAuditParameters?.sTanNo || '',
      sEPFNo: this.dataCommonAuditParameters?.sEPFNo || '',
      isSpecialReport: this.dataCommonAuditParameters?.isSpecialReport || false,
      sWorkingCapital: this.dataCommonAuditParameters?.sWorkingCapital || 0,
      sAuditFee: this.dataCommonAuditParameters?.sAuditFee || 0,
      sDateOfDetection: this.dataCommonAuditParameters?.sDateOfDetection
        ? new Date(this.dataCommonAuditParameters.sDateOfDetection).toLocaleDateString('en-GB')
        : '',
      dAuditAllotmentDate: this.dataCommonAuditParameters?.dAuditAllotmentDate
        ? new Date(this.dataCommonAuditParameters.dAuditAllotmentDate).toLocaleDateString('en-GB')
        : '',

      dAuditStartDate: this.dataCommonAuditParameters?.dAuditStartDate ?
        new Date(this.dataCommonAuditParameters.dAuditStartDate).toLocaleDateString('en-GB')
        : '',
      dSubmitDate: this.dataCommonAuditParameters?.dSubmitDate ?
        new Date(this.dataCommonAuditParameters.dSubmitDate).toLocaleDateString('en-GB')
        : '',
      dDateOfElection: this.dataCommonAuditParameters?.dDateOfElection ?
        new Date(this.dataCommonAuditParameters.dDateOfElection).toLocaleDateString('en-GB')
        : '',
      dGeneralHouseMeeting: this.dataCommonAuditParameters?.dGeneralHouseMeeting ?
        new Date(this.dataCommonAuditParameters.dGeneralHouseMeeting).toLocaleDateString('en-GB')
        : '',
      sAmountInvolved: this.dataCommonAuditParameters?.sAmountInvolved || 0,
      transId: this.dataCommonAuditParameters?.transId || 0,
      sAuditYear: this.dataCommonAuditParameters?.sAuditYear || 0,
      sAuditClassification: this.dataCommonAuditParameters?.sAuditClassification || '',
      sAuditorName: this.dataCommonAuditParameters?.sAuditorName || '',

      govtShare: this.dataCommonAuditParameters?.govtShare || 0,
      redemptionGovtShare: this.dataCommonAuditParameters?.redemptionGovtShare || 0,
      govtDividentPayable: this.dataCommonAuditParameters?.govtDividentPayable || 0,
      govtDividentPaid: this.dataCommonAuditParameters?.govtDividentPaid || 0,
      govtLoan: this.dataCommonAuditParameters?.govtLoan || 0,
      recoveryOfPrincipalInt: this.dataCommonAuditParameters?.recoveryOfPrincipalInt || 0,
      specifyFacilitiesService: this.dataCommonAuditParameters?.specifyFacilitiesService || '',
      totalshare: this.dataCommonAuditParameters?.totalshare || 0,
      govtshares: this.dataCommonAuditParameters?.govtshares || false,
      member: this.dataCommonAuditParameters?.member || 0,


    };

    this.newBalance = {
      iSocietyCommonParameterID: this.dataCommonAuditParameters?.iSocietyCommonParameterID || 0,
      type: this.lstBalanceSheet?.type || '',
      sAmount: this.lstBalanceSheet?.sAmount || '',
      sParameterType: this.lstBalanceSheet?.sParameterType || '',
      OtherParameter: this.lstBalanceSheet?.OtherParameter || '',
      transId: this.lstBalanceSheet?.transId || 0,
    };

  }

  NextButton(currentToggleId: string) {
    if (this.areRequiredFieldsFilled()) {
      this.closeCurrentToggle(currentToggleId);
      this.toggleNextCollapse(currentToggleId);
      this.saveCurrentToggle(currentToggleId);
    } else {
      this.toastService.showError('Please fill in all required fields before proceeding.');
    }
  }

  areRequiredFieldsFilled(): boolean {
    return true; // Implement your validation logic here
  }

  closeCurrentToggle(currentToggleId: string) {
    const toggle = document.getElementById(currentToggleId) as HTMLElement;
    if (toggle?.classList.contains('show')) {
      toggle.classList.remove('show');
    }
  }

  toggleNextCollapse(currentToggleId: string) {
    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive', // Credit Society Toggle
      'collapseSix',
      'collapseSeven'
    ];

    let nextToggleId: string | null = null;
    const currentIndex = allToggleIds.indexOf(currentToggleId);

    if (currentIndex === -1) return; // If currentToggleId is not found, do nothing

    if (this.isCreditSociety && currentToggleId === 'collapseFour') {
      // If Credit society and the user is on collapseFour, open collapseFive next
      nextToggleId = 'collapseFive';
    } else {
      // Otherwise, move to the next toggle normally
      if (currentIndex < allToggleIds.length - 1) {
        nextToggleId = allToggleIds[currentIndex + 1];
      }
    }

    if (nextToggleId) {
      this.toggleCollapse(nextToggleId);
    }
  }


  toggleCollapse(toggleId: string) {
    const toggle = document.getElementById(toggleId) as HTMLElement;
    if (toggle) {
      toggle.classList.add('show');
    }
  }

  saveCurrentToggle(currentToggleId: string) {
    localStorage.setItem(currentToggleId, 'completed');
  }

  previousButton(currentToggleId: string) {
    const previousToggleId = this.getPreviousToggleId(currentToggleId);
    if (previousToggleId) {
      this.toggleCollapse(previousToggleId);
    }
  }

  getPreviousToggleId(currentToggleId: string): string | null {
    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive',
      'collapseSix',
      'collapseSeven'
    ];

    const currentIndex = allToggleIds.indexOf(currentToggleId);
    if (currentIndex > 0) {
      return allToggleIds[currentIndex - 1];
    }
    return null;
  }

  openPreviousTogglesIfFilled(currentToggleId: string) {
    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive',
      'collapseSix',
      'collapseSeven'
    ];

    const currentIndex = allToggleIds.indexOf(currentToggleId);

    for (let i = 0; i < currentIndex; i++) {
      const toggleId = allToggleIds[i];
      const toggleStatus = localStorage.getItem(toggleId);

      if (toggleStatus === 'completed') {
        this.toggleCollapse(toggleId);
      }
    }
  }

  GetCommanData(): void {

    this.auditService.getCommanDatas().subscribe(
      (response) => {
        if (response.status === 200) {
          this.status = response.data.status;

          this.gender = response.data.gender;
          this.category = response.data.castecategory;
          this.balanceSheet = response.data.balanceSheet;
          this.bsParameter = response.data.bsParameter;

          //   this.toastService.showSuccess(response.message);

        } else {
          // this.toastService.showError(response.message);
        }
      },
      (error) => {
        // this.toastService.showError(error.message);

      }
    );
  }
  loadAuditors(iSocietyDetailsId: number): void {
    this.auditService.getSocietyDetails(iSocietyDetailsId).subscribe(
      (response: any) => {
        if (response && response.data && response.data.length > 0) {
          this.filteredData = response.data;
          const firstItem = this.filteredData[0];

          const transId = firstItem?.iSocietyTransID ?? 0;


          // Assign values safely
          this.building = {
            societyBuilding: firstItem.societyBuilding || false,
            buildingType: firstItem.buildingType || '',
            sRemarks: firstItem.sRemarks || '',
            landDetails: firstItem.landDetails || false,
            possessionType: firstItem.possessionType || '',
            sArea: firstItem.sArea || 0,
            iSocietyTransID: transId,
          };

          // Boolean conditions for society types
          this.isNonCreditSociety = firstItem.society === 'Non-Credit';
          this.isCreditSociety = firstItem.society === 'Credit';
          this.primarySociety = firstItem.level === 'Primary';
          this.apexSociety = firstItem.level === 'Apex' || firstItem.level === 'Secondary';
        } else {
          console.warn("No data found for Society ID:", iSocietyDetailsId);
        }
      },
      (error) => {
        console.error("Error fetching society details:", error);
      }
    );
  }


  setPage(iSocietyDetailsId: any): void {

    this.loading = true;
    this.allDataLoaded = false;

    // Define table columns
    this.columns = [
      { prop: 'sSocietyEmpType', name: 'Employee Type' },
      { prop: 'noOfEmployees', name: 'No. of Employees' }
    ];

    // Fetch employee details
    this.auditService.getAllEmployeeDetails(iSocietyDetailsId).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.Empdatas = response.data;
          // this.toastService.showSuccess(response.message);
        } else {
          // this.toastService.showError("No data found.");
        }
        this.loading = false;
        this.allDataLoaded = true;
      },
      error: (error: any) => {
        // this.toastService.showError(error?.message || "An error occurred while fetching data.");
        this.loading = false;
      }
    });
  }


  // Method to fetch balanceSheet details

  getBalanceList(): void {
    this.loading = true;
    this.allDataLoaded = false;

    // Define column structure (if needed)
    this.column = [
      { prop: 'type', name: 'Type' },
      { prop: 'sParameterType', name: 'Type Value' },
      { prop: 'sAmount', name: 'Amount' }
    ];

    // API call to fetch balance details
    this.auditService.getAllBalanceDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        if (response?.data && response.data.length > 0) {
          // Separate Liabilities and Assets
          this.rowsesLiabilities = response.data.filter((item: any) => item.type === 'Libalities');
          this.rowsAssets = response.data.filter((item: any) => item.type === 'Assests');
        } else {
          console.warn("No data received from API");
          this.rowsesLiabilities = [];
          this.rowsAssets = [];
        }

        this.loading = false;
        this.allDataLoaded = true;
      },
      error: (error: any) => {
        console.error("Error fetching data:", error);
        this.loading = false;
      }
    });
  }

  getBorrowerList(): void {

    this.loading = true;
    this.allDataLoaded = false;

    // Define table columns
    this.cols = [
      { prop: 'sCasteCategory', name: 'Caste Category' },
      { prop: 'sDefaulterName', name: 'No. of Defaulters' },
      { prop: 'sAmount', name: 'Amount' }
    ];

    // Fetch employee details
    this.auditService.getAllBorrowerDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.Borrowerdatas = response.data;
          //this.page.totalRecords = response.totalRecords;
        }
        this.loading = false;
        this.allDataLoaded = true;
      },
      error: (error: any) => {
        // this.toastService.showError(error?.message || "An error occurred while fetching data.");
        this.loading = false;
      }
    });
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name);
      if (
        this.fileExtension !== 'jpg' &&
        this.fileExtension !== 'jpeg' &&
        this.fileExtension !== 'png' &&
        this.fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        return;
      }
      this.selectedFile = event.target.files[0];
      this.convertToBase64(file, 1);
      this.cd.detectChanges();
    }
  }
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }

  EmpData() {
    this.loading = true;
    this.auditService.getEmployeeDetails().subscribe({
      next: (response) => {
        this.loading = false;

        if (response && response.status === 200) {
          this.FatchedData = response.data;
          this.page.totalRecords = response.totalRecords;
          // this.toastService.showSuccess(response.message);
          this.allDataLoaded = true;
        } else {
          this.rows = [];
          this.page.totalRecords = 0;
          //  this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.loading = false;
        // this.toastService.showError(error.message);
      }
    });
  }
  UpdateStatus(iSocietyDetailsId: number) {
    if (!this.StatusFormValid()) {
      this.toastService.showError('Please fill out the required fields.');
      return;
    }

    this.auditService.getSocietyDetails(iSocietyDetailsId).subscribe({
      next: (response: any) => {
        if (response?.data?.length > 0) {
          const firstItem = response.data[0];
          const transId = firstItem?.iSocietyTransID ?? 0;
          this.newUpload.transId = transId;
          this.newUpload.documentPath = this.base64String || '';
          this.newUpload.documentFileName = this.fileName;
          this.newUpload.documentExtension = this.fileExtension;
          // Call StatusUpdate API
          this.auditService.StatusUpdat(this.newUpload, iSocietyDetailsId).subscribe({
            next: (res: any) => {
              if (res.status === 200) {
                this.AuditStatus = res.data;
                this.toastService.showSuccess(res.message);
                window.location.reload();

              } else {
                this.toastService.showError('Failed to update status.');
                this.showDownload = false;
              }
            },
            error: (err) => {
              this.toastService.showError(err.message || 'Failed to update status.');
              this.showDownload = false;
            }
          });
        } else {
          this.toastService.showError('No transaction data available.');
          this.showDownload = false;
        }
      },
      error: (err) => {
        this.toastService.showError('Error fetching transaction details.');
        console.error('Error fetching society details:', err);
        this.showDownload = false;
      }
    });
  }



  StatusFormValid(): boolean {
    return !!(this.newUpload.documentPath && this.newUpload.status && this.newUpload.isChecked);
  }

  submitAuditorForm(form: NgForm) {
    if (!form.valid) {
      this.toastService.showError('Please fill out the form correctly.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe(
      (response: any) => {
        const firstItem = response?.data?.[0];
        if (!firstItem) {
         // this.toastService.showError('No transaction data available.');
          return;
        }

        this.newEMP.transId = firstItem.iSocietyTransID ?? 0; // Assign transaction ID
        this.auditService.addEmployee(this.newEMP).subscribe(
          (res) => {
         //   this.toastService.showSuccess(res.message); // Show success message

            this.setPage(this.iSocietyDetailsId); // Set the page after success
          },
          (err) => {
           // this.toastService.showError(err.message); // Show error message
          }
        );


      },
      (error) => {
        console.error('Error fetching transaction ID:', error);
        this.toastService.showError('Failed to fetch transaction ID.');
      }
    );
  }

  submitBorrowersForm(formBorr: NgForm) {
    if (!formBorr.valid) {
      this.toastService.showError('Please fill out the form correctly.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe(
      (response: any) => {
        const firstItem = response?.data?.[0];

        if (firstItem) {
          this.borrower.transId = firstItem.iSocietyTransID ?? 0;

          this.auditService.addBorrower(this.borrower).subscribe(
            (res) => {
              this.toastService.showSuccess(res.message);
              this.getBorrowerList();
            },
            (err) => this.toastService.showError(err.message)
          );
        }

        else {
          this.toastService.showError('No transaction data available.');
        }
      },
      (error) => this.toastService.showError('Error fetching transaction details.')
    );
  }


  submitBalanceForm(newBalance: NgForm) {
    if (!newBalance.valid) {
      this.toastService.showError('Please fill out the form correctly.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        const firstItem = response?.data?.[0]; // Extract first item safely
        if (!firstItem) {
          this.toastService.showError('No transaction data available.');
          return;
        }

        this.newBalance.transId = firstItem.iSocietyTransID ?? 0;

        this.auditService.addBalance(this.newBalance).subscribe({
          next: (res) => {
            this.toastService.showSuccess(res.message);
            this.getBalanceList();
          },
          error: (err) => this.toastService.showError(err.message),
        });
      },
      error: (err) => {
        this.toastService.showError('Failed to fetch transaction ID.');
        console.error('Error fetching transaction ID:', err);
      }
    });
  }
  submitCommanPerameterForm() {
    if (!this.commonPerameterFormValid()) {
      this.toastService.showError('Please fill out the required fields.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        const firstItem = response?.data?.[0]; // Extract first item safely
        if (!firstItem) {
          this.toastService.showError('No transaction data available.');
          return;
        }

        this.commanPerameter.transId = firstItem.iSocietyTransID ?? 0;
        // Submit the common parameter form
        this.auditService.addCommonParameter(this.commanPerameter).subscribe({
          next: (res) => {
            this.toastService.showSuccess(res?.message || 'Submitted successfully.');
            this.isEditing = false;


          },
          error: (err) => {
            console.error('Error submitting common parameter:', err);
            this.toastService.showError(err?.message || 'An error occurred while submitting.');
          }
        });
      },
      error: (err) => {
        console.error('Error fetching transaction ID:', err);
        this.toastService.showError('Failed to fetch transaction ID.');
      }
    });
  }


  commonPerameterFormValid() {
    let isValid = true;

    if (
      !this.commanPerameter.sDateOfDetection ||
      !this.commanPerameter.sAmountInvolved ||
      !this.commanPerameter.sAuditFee ||
      !this.commanPerameter.sWorkingCapital ||
      !this.commanPerameter.sEPFNo ||
      !this.commanPerameter.sTanNo ||
      !this.commanPerameter.sPANNo ||
      !this.commanPerameter.sGSTNO ||
      !this.commanPerameter.sExpenditure ||
      !this.commanPerameter.sIncome ||
      !this.commanPerameter.totalshare ||
      !this.commanPerameter.member ||
      !this.commanPerameter.specifyFacilitiesService
    ) {
      isValid = false;
    }

    if (this.commanPerameter.govtshares === true) {
      if (
        !this.commanPerameter.govtShare ||
        !this.commanPerameter.redemptionGovtShare ||
        !this.commanPerameter.govtDividentPayable ||
        !this.commanPerameter.govtDividentPaid ||
        !this.commanPerameter.govtLoan ||
        !this.commanPerameter.recoveryOfPrincipalInt
      ) {
        isValid = false;
      }
    }
    if (this.commanPerameter.dAuditStartDate && this.commanPerameter.dSubmitDate) {
      const startDate = this.commanPerameter.dAuditStartDate;
      const submissionDate = this.commanPerameter.dSubmitDate;


      if (submissionDate <= startDate) {
        isValid = false;
        this.toastService.showError("Submission Date must be after the Start Date.");

      }
    }

    return isValid;
  }

  submitAuditPeraForm() {
    if (!this.AuditFormValid()) {
      this.toastService.showError('Please fill out the required fields.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        const firstItem = response?.data?.[0]; // Extract first item safely
        if (!firstItem) {
          this.toastService.showError('No transaction data available.');
          return;
        }

        this.newAuditPera.transid = firstItem.iSocietyTransID ?? 0;

        this.auditService.addAuditPera(this.newAuditPera).subscribe({
          next: (res) => this.toastService.showSuccess(res.message),
          error: (err) => this.toastService.showError(err.message),
        });
      },
      error: (err) => {
        this.toastService.showError('Failed to fetch transaction ID.');
        console.error('Error fetching transaction ID:', err);
      }
    });
  }

  AuditFormValid() {
    let isValid = true;

    if (!this.newAuditPera.sTotalOutStanding || !this.newAuditPera.sSpecificTrainingArea) {
      isValid = false;
    }

    return isValid;
  }

  submitCoprateSocietyForm() {

    if (this.coprateSocietyFormValid()) {
      this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe(
        (response: any) => {
          const firstItem = response?.data?.[0]; // Extract first item safely
          if (!firstItem) {
            this.toastService.showError('No transaction data available.');
            return;
          }

          this.newcoprateSocity.transId = firstItem.iSocietyTransID ?? 0;

          this.auditService.addCoprateSociety(this.newcoprateSocity).subscribe({
            next: (res) => this.toastService.showSuccess(res.message),
            error: (err) => this.toastService.showError(err.message),
          });
        },
        (error) => {
          this.toastService.showError('Failed to fetch transaction ID.');
          console.error("Error fetching transaction ID:", error);
        }
      );
    } else {
      this.toastService.showError('Please fill out the required fields.');
    }
  }
  coprateSocietyFormValid() {
    let isValid = true;

    if (!this.newcoprateSocity.sLoanAgriculture || !this.newcoprateSocity.sLoanNonAgriculture || !this.newcoprateSocity.sLoanDistributionShort ||
      !this.newcoprateSocity.sLoanDistributionMedium || !this.newcoprateSocity.sLoanDistributionLong || !this.newcoprateSocity.sLoanRecoveryShort || !this.newcoprateSocity.sLoanRecoveryMedium || !this.newcoprateSocity.sLoanRecoveryLong || !this.newcoprateSocity.sLoanOutstandingShort || !this.newcoprateSocity.sLoanDistributionLong || !this.newcoprateSocity.sLoanOutstandingMedium || !this.newcoprateSocity.sLoanOutstandingLong || !this.newcoprateSocity.sLoanOverdueShort || !this.newcoprateSocity.sLoanOverdueMedium) {
      isValid = false;
    }

    return isValid;
  }

// downloadDocument(path:any) {
//   if (path) {

//     const fileUrl = path;
//     const link = document.createElement('a');
//     link.href = fileUrl;
//     link.target = '_blank'; 
//     link.download = fileUrl.split('/').pop() || 'downloaded-file'; 
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } else {
//     this.toastService.showError('Document path is not available');
//   }
// }
downloadDocument(fileName: string) {

  const fileUrl = fileName;
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  link.target = '_blank'; 
  link.click();
}
  submitBuildingForm() {
    
    if (this.BuildingformIsValid()) {
      this.auditService.addBuilding(this.building).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    } else {
      this.toastService.showError('Please fill out the required fields.');
    }
  }


  formSubmitted = false;

  BuildingformIsValid() {
    this.formSubmitted = true;
    let isValid = true;

    if (this.building.societyBuilding) {
      if (!this.building.buildingType || !this.building.sRemarks) {
        isValid = false;
      }
    }

    if (this.building.landDetails) {
      if (!this.building.possessionType || !this.building.sArea) {
        isValid = false;
      }
    }

    return isValid;
  }

  submitCommanSocietyForm() {
    if (!this.formIsValid()) {
      this.toastService.showError('Please fill out the required fields.');
      return;
    }
    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe(
      (response: any) => {
        if (response?.data?.length > 0) {
          this.filteredData = response.data;
          const firstItem = response.data[0];
          const transId = firstItem?.iSocietyTransID ?? 0;
          this.newSociety.transId = transId;

          this.auditService.addCommanSociety(this.newSociety).subscribe(
            (res) => {
              this.toastService.showSuccess(res.message);
            },
            (err) => {
              this.toastService.showError(err.message);
            }
          );
        } else {
          this.toastService.showError('No transaction data available.');
        }
      },
      (error) => {
        console.error("Error fetching transaction ID:", error);
        this.toastService.showError('Failed to fetch transaction ID.');
      }
    );
  }

  formIsValid(): boolean {
    if (!this.apexSociety && !this.primarySociety) return false;

    if (this.apexSociety) {
      if (!this.newSociety.noOfMember || this.newSociety.noOfMember < 1 || this.newSociety.noOfMember > 9999 ||
        !this.newSociety.apexInstituteSociety || this.newSociety.apexInstituteSociety < 1 || this.newSociety.apexInstituteSociety > 9999) {
        return false;
      }
    }

    if (this.primarySociety) {
      if (!this.newSociety.gender || !this.newSociety.membercount || this.newSociety.membercount < 1 || this.newSociety.membercount > 9999) {
        return false;
      }
    }

    return !!this.newSociety.statusSocieties && !!this.newSociety.isCorporativeBank;
  }
  submitNonCreditForm() {

    if (this.nonCreditFormValid()) {
      this.auditService.addNonCredit(this.newnonCredit).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    } else {
      this.toastService.showError('Please fill out the required fields.');
    }
  }

  nonCreditFormValid() {
    let isValid = true;

    if (!this.newnonCredit.sTrainingNo || !this.newnonCredit.sSpecificAuditYearArea || !this.newnonCredit.sNoTrainedConducted ||
      !this.newnonCredit.sNoTeachingWorkers || !this.newnonCredit.sNoOtherStaff) {
      isValid = false;
    }

    return isValid;
  }
  updateRemark() {

    if (
      !this.remarksValid() ||
      !this.BuildingformIsValid ||
      !this.formIsValid() ||
      !this.formsturnIsValid() ||
      !this.commonPerameterFormValid ||
      !this.coprateSocietyFormValid ||
      !this.AuditFormValid()
    ) {
      this.toastService.showError('Please fill out all required fields before submitting remarks.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        if (response?.data?.length > 0) {
          const firstItem = response.data[0];
          this.remark.transId = firstItem?.iSocietyTransID ?? 0;

          this.auditService.updateSocietyRemark(this.remark).subscribe({
            next: (res) => {
              this.toastService.showSuccess(res.message);
             
              window.location.reload();

            },
            error: (err) => {
              this.toastService.showError(err.message);
            }
          });
        } else {
          this.toastService.showError('No transaction data available.');
        }
      },
      error: (err) => {
        console.error('Error fetching transaction ID:', err);
        this.toastService.showError('Failed to fetch transaction ID.');
      }
    });
  }


  validateNumber(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  remarksValid() {
    let isValid = true;

    if (!this.remark.remarks) {
      isValid = false;
    }

    return isValid;
  }

  submitChecklistValue() {
    if (!this.formsturnIsValid()) {
      this.toastService.showError('Please fill out the required fields.');
      return;
    }

    this.auditService.getSocietyDetails(this.iSocietyDetailsId).subscribe({
      next: (response: any) => {
        const firstItem = response?.data?.[0]; // Extract first item safely
        if (!firstItem) {
          this.toastService.showError('No transaction data available.');
          return;
        }

        this.newchecked.transId = firstItem.iSocietyTransID ?? 0; // Assign transaction ID

        // Prepare requestData array
        const requestData: any[] = this.lstBussinessUpgrades
          ?.filter((ser: any) => ser.checked) // Filter checked services
          ?.flatMap((ser: any) =>
            ser.lstServiceData.map((selectedSer: any) => ({
              iBussinessSerID: selectedSer.iBussinessSerID ?? 0, // Default 0 if undefined
              transId: this.newchecked.transId ?? 0, // Default 0 if undefined
              iTBussinessFieldID: selectedSer.iTBussinessFieldID ?? 0, // Default 0 if undefined
              value: selectedSer.value !== undefined && selectedSer.value !== null
                ? String(selectedSer.value) // Convert to string if defined
                : 'string' // Default fallback
            }))
          ) || [];


        // Submit the checklist values
        this.auditService.addSocietyBusiness(requestData).subscribe({
          next: (response) => {
            this.toastService.showSuccess(response?.message || 'Submitted successfully.');
            this.updateSelectedServicesList(response);
          },
          error: (error) => {
            console.error('Submission Error:', error);
            this.toastService.showError(error?.message || 'An error occurred while submitting.');
          }
        });
      },
      error: (error) => {
        console.error('Error fetching transaction ID:', error);
        this.toastService.showError('Failed to fetch transaction ID.');
      }
    });
  }
  // Function to check if any checkbox is selected
  checkCheckboxStatus() {
    this.isAnyCheckboxChecked = this.lstBussinessUpgrades.some((ser: any) => ser.checked);
  }

  // Function to handle checkbox change
  onCheckboxChange() {
    this.checkCheckboxStatus(); // Update button status
  }

  formsturnIsValid(): boolean {
    let isValid = true;
    // Validate dynamic service data fields
    this.lstBussinessUpgrades.forEach((service: { checked: boolean; lstServiceData?: any[] }) => {
      if (service.checked && service.lstServiceData?.length) {
        service.lstServiceData.forEach((selectedSer: { isRequired?: boolean; value?: any }) => {
          if (selectedSer.isRequired && !selectedSer.value) {
            isValid = false;
          }
        });
      }
    });

    return isValid;
  }


  updateSelectedServicesList(response: any) {
    if (!response) return;


    // Update selected services
    if (response.societyServiceRequests && Array.isArray(response.societyServiceRequests)) {
      response.societyServiceRequests.forEach((serviceReq: { iBussinessSerID: number | string; iTBussinessFieldID: number; value: string }) => {
        let service = this.lstBussinessUpgrades.find((ser: { id: number | string }) => ser.id === serviceReq.iBussinessSerID);
        if (service) {
          let selectedSer = service.lstServiceData.find((s: { id: number }) => s.id === serviceReq.iTBussinessFieldID);
          if (selectedSer) {
            selectedSer.value = serviceReq.value;
            selectedSer.iTBussinessFieldID = serviceReq.iTBussinessFieldID;
          }
        }
      });
    }
  }


  updateSelectedServices(id: number) {

    let selectedService = this.lstBussinessUpgrades.find(
      (service: { name: string; checked: boolean; id: number }) => service.id === id
    );

    if (selectedService && Array.isArray(selectedService.lstServiceData)) {
      let checkedServices = selectedService.lstServiceData.filter((service: any) => service.checked);

      if (checkedServices.length > 0) {
        this.selectedServices = [
          {
            name: selectedService.name,
            lstServiceData: checkedServices.map((service: any) => ({
              fieldName: service.fieldName || '',
              value: service.value || '',
              dataType: service.dataType || 'text',
              isRequired: service.isRequired || false,
              iTBussinessFieldID: service.iTBussinessFieldID || 0,
              checked: service.checked || false
            }))
          }
        ];
      } else {
        this.selectedServices = [];
      }
    } else {
      console.error("No valid service data found for ID:", id);
      this.selectedServices = [];
    }

  }



  onRowActivate(event: any) {
  }

  toggleRowSelection(event: any, row: any) {
  }

  //Open delete Model
  openDeleteModal(iTSocietyEmpID: number, iBalanceSheetID: number, iSocietyBorrowerDetails: number, entityType: string): void {
    this.iTSocietyEmpID = iTSocietyEmpID;
    this.iBalanceSheetID = iBalanceSheetID;
    this.iSocietyBorrowerDetails = iSocietyBorrowerDetails;
    if (entityType === 'Employee') {
      this.confirmationMessage = `Are you sure you want to delete employee with ID: ${iTSocietyEmpID}?`;
    } else if (entityType === 'Balance') {
      this.confirmationMessage = `Are you sure you want to delete the balance sheet with ID: ${iBalanceSheetID}?`;
    } else if (entityType === 'Borrower') {
      this.confirmationMessage = `Are you sure you want to delete the borrower with ID: ${iSocietyBorrowerDetails}?`;
    }
  }

  confirmDelete(): void {
    if (this.iTSocietyEmpID !== 0) {
      this.auditService.deleteEmployee(this.iTSocietyEmpID).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.setPage(this.iSocietyDetailsId);
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    }
    else if (this.iBalanceSheetID !== 0) {
      this.auditService.deleteBalance(this.iBalanceSheetID).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.getBalanceList();

        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    }
    else if (this.iSocietyBorrowerDetails !== 0) {
      this.auditService.deleteBorrower(this.iSocietyBorrowerDetails).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.getBorrowerList();
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    }
    else {
      this.toastService.showError("Invalid ID provided.");
    }
  }

}
